<template>
  <v-container class="price-tier-list" fluid>
    <v-row>
      <v-col>
        <v-data-table :items="priceTiers"
                      :headers="priceTierHeaders"
                      item-class="price-tier-list-table-body"
                      hide-default-footer>
          <template v-slot:item.actions="data">
            <font-awesome-icon icon="edit"
                               class="mr-3"
                               @click.stop="editItem(data.item)"></font-awesome-icon>
            <font-awesome-icon icon="trash"
                               @click.stop="deleteItem(data.item)"></font-awesome-icon>
          </template>
        </v-data-table>
      </v-col>
      <v-col>
        <v-row>
          <v-col>
            {{ editingPriceTier.id ? $t('admin_acc_price_tier.edit_title') : $t('admin_acc_price_tier.add_title') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_price_tier.name_en')"
                          :placeholder="$t('admin_acc_price_tier.name_en')"
                          v-model="editingPriceTier.name_en">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_price_tier.name_zh')"
                          :placeholder="$t('admin_acc_price_tier.name_zh')"
                          v-model="editingPriceTier.name_zh">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          type="number"
                          min="0"
                          :label="$t('admin_acc_price_tier.price')"
                          :placeholder="$t('admin_acc_price_tier.price')"
                          v-model="editingPriceTier.price">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_price_tier.legend_en')"
                          :placeholder="$t('admin_acc_price_tier.legend_en')"
                          v-model="editingPriceTier.legend_en">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field outlined
                          :label="$t('admin_acc_price_tier.legend_zh')"
                          :placeholder="$t('admin_acc_price_tier.legend_zh')"
                          v-model="editingPriceTier.legend_zh">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-right">
            <v-btn color="#dddddd" @click="resetItem" class="mr-3">
              {{ $t('reset') }}
            </v-btn>
            <v-btn color="#2bc7ca" @click="saveItem">
              {{ $t('save') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";

export default {
  name: 'PriceTierList',
  props: {
    typeId: String,
  },
  setup(props, {root, emit}) {
    const editingPriceTier = ref({});
    const priceTiers = ref([]);
    const priceTierHeaders = [
      {text: root.$t('admin_acc_price_tier.name_en'), value: 'name_en'},
      {text: root.$t('admin_acc_price_tier.name_zh'), value: 'name_zh'},
      {text: root.$t('admin_acc_price_tier.price'), value: 'price'},
      {text: '', value: 'actions'},
    ];
    const getPriceTiers = function () {
      root.$callAPI('room/admin/item_type/price_tier/', {
        type_id: props.typeId,
      }, function (response) {
        priceTiers.value = response.body.price_tiers;
      });
    };
    const editItem = function (item) {
      editingPriceTier.value = item;
    };
    const resetItem = function () {
      editingPriceTier.value = {};
    };
    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_price_tier.confirm_delete'))) {
        root.$callAPI('room/admin/item_type/price_tier/delete/', {
          id: item.id,
        }, function (response) {
          resetItem();
          getPriceTiers();
        });
      }
    };
    const saveItem = function () {
      root.$callAPI('room/admin/item_type/price_tier/set/', {
        type_id: props.typeId,
        ...editingPriceTier.value,
      }, function (response) {
        resetItem();
        getPriceTiers();
      });
    };

    onMounted(() => {
      getPriceTiers();
    })

    return {
      editingPriceTier,
      priceTiers,
      priceTierHeaders,

      editItem,
      deleteItem,
      resetItem,
      saveItem,
    };
  },
}
</script>

<style lang="less">
.price-tier-list {
  .price-tier-list-table-body {
    svg {
      font-size: 1.5em;
      margin-left: 5px;
    }

    .fa-edit, .fa-trash {
      cursor: pointer;

      &:hover {
        color: #0070ff;
      }
    }
  }
}
</style>
